import { OwnershipTypeWizard } from '../domain/types';

export const ownershipTypeWizardLabels: {
  [key in OwnershipTypeWizard]: string;
} = {
  INTERA_PROPRIETA: 'Piena proprietà',
  NUDA_PROPRIETA: 'Nuda proprietà',
  ALTRO: 'Altro',
};
